import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { ContinuousEcgAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-continuous-ecg-slot',
    templateUrl: './continuous-ecg-slot.component.html',
    styleUrl: './continuous-ecg-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContinuousEcgSlotComponent implements SheetSlotComponentBase {

	@Input() action!: ContinuousEcgAction;
	value = null;

	constructor() {
	}
}